;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Collection 	= APP.module('Collection');

	Collection.MenuItemsMobile = Collection.MenuItemsMobile.extend({
		default_items: [
			{
				path: 'tipping',
				name: 'Tipping'
			},
			{
				path: 'tipping/leagues',
				name: 'Comps'
			},
			{
				path: 'tipping/rankings',
				name: 'Rankings'
			},
			{
				name: 'Help',
				sub_menu: [
					{
						method_name: "guidelines",
						path: 'help/game-guidelines',
						name: 'Game Guidelines'
					},
					{
						method_name: "rules",
						path: 'help/game-rules',
						name: 'Game Rules'
					},
					{
						method_name: "faqs",
						path: 'help/faqs',
						name: 'FAQs'
					},
					{
						method_name: "terms",
						path: 'help/terms',
						name: 'Terms & Conditions'
					},
					{
						method_name: "contactUs",
						path: 'help/contact-us',
						name: 'Contact Us'
					}
				],
				sub_menus_list:  [
					{
						menu: [
							{
								method_name: "guidelines",
								path: 'help/game-guidelines',
								name: 'Game Guidelines'
							},
							{
								method_name: "rules",
								path: 'help/game-rules',
								name: 'Game Rules'
							},
							{
								method_name: "faqs",
								path: 'help/faqs',
								name: 'FAQs'
							},
							{
								method_name: "terms",
								path: 'help/terms',
								name: 'Terms & Conditions'
							},
							{
								method_name: "contactUs",
								path: 'help/contact-us',
								name: 'Contact Us'
							}
						]
					}
				]
			}
		],

		off_season_items: [
			{
				path: 'off-season',
				name: 'Home'
			},
			{
				name: 'Help',
				sub_menu: [
					{
						method_name: "guidelines",
						path: 'off-season/help/game-guidelines',
						name: 'Game Guidelines'
					},
					{
						method_name: "rules",
						path: 'off-season/help/game-rules',
						name: 'Game Rules'
					},
					{
						method_name: "faqs",
						path: 'off-season/help/faqs',
						name: 'FAQs'
					},
					{
						method_name: "terms",
						path: 'off-season/help/terms',
						name: 'Terms & Conditions'
					}
				],
				sub_menus_list:  [
					{
						menu: [
							{
								method_name: "guidelines",
								path: 'off-season/help/game-guidelines',
								name: 'Game Guidelines'
							},
							{
								method_name: "rules",
								path: 'off-season/help/game-rules',
								name: 'Game Rules'
							},
							{
								method_name: "faqs",
								path: 'off-season/help/faqs',
								name: 'FAQs'
							},
							{
								method_name: "terms",
								path: 'off-season/help/terms',
								name: 'Terms & Conditions'
							}
						]
					}
				]
			}
		],
		non_authorized: [
			{
				method_name: "index",
				path: "login",
				name: "Home"
			},
			{
				method_name: "prizes",
				path: "help/prizes",
				name: "Prizes"
			},
			{
				method_name: "faqs",
				path: "help/faqs",
				nested_method_name: ['rules', 'terms', 'contactUs','guidelines'],
				name: 'Help',
				type: "afl"
			},
		],

		defaults: {},

		setDefaults: function(){
			if (!APP.module('instance').user || !APP.module('instance').user.get('id')) {
				this.reset($.extend(true, [], this.non_authorized));
				return this;
			}
			this.reset($.extend(true, [], CONFIG.OFF_SEASON ? this.off_season_items : this.default_items));

			return this;
		}
	});
}(window, APP, Backbone, Marionette, $, _));

